module.exports = __webpack_public_path__ + "img/ksyun.b0ac5b68.svg";